import { useMemo } from "react";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/es"; // español
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./Calendar.css";

const localizer = momentLocalizer(moment);

const Calendar = ({ events }) => {
  const eventStyleGetter = (event) => {
    const backgroundColor = event.color || "#3182ce";
    return {
      style: {
        backgroundColor,
        borderRadius: "6px",
        opacity: 0.9,
        color: "white",
        border: "none",
        display: "block",
        fontWeight: 500,
      },
    };
  };

  const messages = useMemo(
    () => ({
      next: "Sig.",
      previous: "Ant.",
      today: "Hoy",
      month: "Mes",
      week: "Semana",
      day: "Día",
      agenda: "Agenda",
      showMore: (total) => `+${total} más`,
    }),
    []
  );

  return (
    <div style={{ height: "90vh", padding: "20px" }}>
      <BigCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        titleAccessor="title"
        views={["month", "week", "day"]}
        messages={messages}
        eventPropGetter={eventStyleGetter}
        popup
        culture="es"
      />
    </div>
  );
};

export default Calendar;
